<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip }">
      <v-btn large icon v-on="tooltip" @click="downloadFile">
        <v-icon>mdi-file-download-outline</v-icon>
      </v-btn>
    </template>
    <span>Download Disavow</span>
  </v-tooltip>
</template>

<script>
import APIService from "@/services/APIService.js";
export default {
  methods: {
    downloadFile() {
      return APIService.getDownloadFile(this.$route.params.id)
        .then(response => {
          const blob = new Blob([response.data], { type: "text/plain" });
          const url = window.URL.createObjectURL(blob);
          let fileLink = document.createElement("a");
          fileLink.href = url;
          fileLink.download = "disavow.txt";
          fileLink.click();
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style></style>
